interface AccountInfoProps {
    title?: string;
    depositor?: string;
    accountNo?: string;
    bankName?: string;
}

export const AccountInfo =  ({ title, depositor, accountNo, bankName }: AccountInfoProps) => {

    return (
        <>
            <section className="bg-white">
                <div className="inner-box">
                    <div className="form-item">
                        <label htmlFor="" className="input-tit big">{title}</label>
                        <div className="info-row">
                            <span className="label">예금주</span>
                            <span className="cont">{depositor}</span>
                        </div>
                        <div className="info-row">
                            <span className="label">은행</span>
                            <span className="cont">{bankName}</span>
                        </div>
                        <div className="info-row">
                            <span className="label">계좌번호</span>
                            <span className="cont">{accountNo}</span>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
};